import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesSchemesAssociateDefaultRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-schemes-associate-default',
	path: '/secure/admin/AssociateIssueTypeSchemesWithDefault!default.jspa',
};
